import { fetchPurchaseMotions } from 'pricing-pages-lib/api/EligibilityEngineApi';
import { useEffect, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionTitle = styled.h3.withConfig({
  displayName: "ConstantsTest__SectionTitle",
  componentId: "sc-9y7hel-0"
})(["margin-top:10px;margin-bottom:5px;"]);
const ConstantsTest = () => {
  const [eePurchaseMotions, setEePurchaseMotions] = useState(null);
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  useEffect(() => {
    fetchPurchaseMotions().then(result => setEePurchaseMotions(result)).catch(err => console.log('err', err));
  }, []);
  const fePurchaseMotions = Object.values(PurchaseMotionTypes);
  const frontEndOnly = fePurchaseMotions.filter(type => eePurchaseMotions && !eePurchaseMotions.includes(type));
  const eligibilityEngineOnly = eePurchaseMotions && eePurchaseMotions.filter(type => !fePurchaseMotions.includes(type));
  if (!eePurchaseMotions || eePurchaseMotions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    style: {
      margin: '20px'
    },
    "data-selenium-id": "purchase-motions",
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: "TEST_CONSTANTS_PAGE"
    }), frontEndOnly.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: "UI-Addon-Upgrades Purchase Motions not present in E.E."
      }), /*#__PURE__*/_jsx("div", {
        children: frontEndOnly.map(value => /*#__PURE__*/_jsx("div", {
          "data-selenium-id": "back-end-purchase-motion",
          children: value
        }, value))
      })]
    }), eligibilityEngineOnly && eligibilityEngineOnly.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: "E.E. Purchase Motions not present in UI-Addon-Upgrades"
      }), /*#__PURE__*/_jsx("div", {
        children: eligibilityEngineOnly.map(value => /*#__PURE__*/_jsx("div", {
          "data-selenium-id": "back-end-purchase-motion",
          children: value
        }, value))
      })]
    })]
  });
};
export default ConstantsTest;